import { render, staticRenderFns } from "./Tool.vue?vue&type=template&id=0f12f24a&scoped=true"
import script from "./Tool.vue?vue&type=script&lang=js"
export * from "./Tool.vue?vue&type=script&lang=js"
import style0 from "./Tool.vue?vue&type=style&index=0&id=0f12f24a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f12f24a",
  null
  
)

export default component.exports